import { requireBrowserEnv } from "./formConstants";

export const UPSELL_OFFERS = {
  combo: {
    offerId: "combo",
    priceId: requireBrowserEnv("REACT_APP_UPSELL_COMBO_PRICE_ID"),
    productId: requireBrowserEnv("REACT_APP_UPSELL_COMBO_PRODUCT_ID"),
  },
  hair: {
    offerId: "hair",
    priceId: requireBrowserEnv("REACT_APP_UPSELL_HAIR_PRICE_ID"),
    productId: requireBrowserEnv("REACT_APP_UPSELL_HAIR_PRODUCT_ID"),
  },
  outfits: {
    offerId: "outfits",
    priceId: requireBrowserEnv("REACT_APP_UPSELL_OUTFITS_PRICE_ID"),
    productId: requireBrowserEnv("REACT_APP_UPSELL_OUTFITS_PRODUCT_ID"),
  },
};
